document.addEventListener('DOMContentLoaded', function () {
  var replacements = [
    ['Mens Imperium Collection', "Men's Imperium Collection"],
    ['Mens Classic Collection', "Men's Classic Collection"],
    ['Womens Imperium Collection', "Women's Imperium Collection"],
    ['All Men', "Shop Men's"],
    ['All Women', "Shop Women's"],
    ['Mens', "Men's"],
    ['Womens', "Women's"],
    ['Capsule collections', 'Capsule Collections'],
    ['Cheats and thieves', 'Cheats and Thieves'],
    ['Gr8 reset', 'Gr8 Reset'],
    ['Strength.Grace.Authority.', 'Strength. Grace. Authority.'],
    ['Built for Those who Stand Firm', 'Built for those who stand firm'],
    ['SHOP ESSENTIALS >', 'Shop Essentials >'],
    ['Inspired by history.', 'Inspired by History.'],
    ['Conqueror Signature Shorts set', 'Conqueror Signature Shorts Set']
  ];

  var selectors = ['.Header', '#sidebar-menu', '.Footer', '.template-index #main'];

  selectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;

      while ((node = walker.nextNode())) {
        var text = node.nodeValue;
        var updated = text;

        replacements.forEach(function (pair) {
          updated = updated.split(pair[0]).join(pair[1]);
        });

        if (updated !== text) {
          node.nodeValue = updated;
        }
      }
    });
  });
});
